import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "header-info" }
const _hoisted_3 = {
  key: 0,
  class: "emp-count"
}
const _hoisted_4 = { class: "emp-selector-wrapper" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "family-badge"
}
const _hoisted_8 = { class: "emp-meta" }
const _hoisted_9 = { class: "header-actions" }
const _hoisted_10 = { class: "help-header" }
const _hoisted_11 = { class: "help-title" }
const _hoisted_12 = { class: "help-body" }
const _hoisted_13 = { class: "help-section" }
const _hoisted_14 = { class: "section-title" }
const _hoisted_15 = { class: "section-icon" }
const _hoisted_16 = { class: "help-section" }
const _hoisted_17 = { class: "section-title" }
const _hoisted_18 = { class: "section-icon" }
const _hoisted_19 = { class: "help-section" }
const _hoisted_20 = { class: "section-title" }
const _hoisted_21 = { class: "section-icon" }
const _hoisted_22 = { class: "help-section" }
const _hoisted_23 = { class: "section-title" }
const _hoisted_24 = { class: "section-icon" }
const _hoisted_25 = { class: "help-section" }
const _hoisted_26 = { class: "section-title" }
const _hoisted_27 = { class: "section-icon" }
const _hoisted_28 = { class: "help-section" }
const _hoisted_29 = { class: "section-title" }
const _hoisted_30 = { class: "section-icon" }
const _hoisted_31 = { class: "help-section" }
const _hoisted_32 = { class: "section-title" }
const _hoisted_33 = { class: "section-icon" }
const _hoisted_34 = { class: "help-section" }
const _hoisted_35 = { class: "section-title" }
const _hoisted_36 = { class: "section-icon" }
const _hoisted_37 = { class: "help-footer" }
const _hoisted_38 = { class: "start-date-header" }
const _hoisted_39 = { class: "start-date-title" }
const _hoisted_40 = { class: "start-date-body" }
const _hoisted_41 = { class: "emp-info-row" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "date-section" }
const _hoisted_44 = { class: "date-section-title" }
const _hoisted_45 = { class: "emp-info-row" }
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "date-input-row" }
const _hoisted_48 = ["max"]
const _hoisted_49 = { class: "date-section" }
const _hoisted_50 = { class: "date-section-title" }
const _hoisted_51 = { class: "emp-info-row" }
const _hoisted_52 = { class: "value" }
const _hoisted_53 = { class: "date-input-row" }
const _hoisted_54 = { class: "date-input-wrapper" }
const _hoisted_55 = ["min", "max", "disabled"]
const _hoisted_56 = { class: "end-date-toggle" }
const _hoisted_57 = { class: "warning-text" }
const _hoisted_58 = { class: "start-date-footer" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "tabs" }
const _hoisted_61 = {
  key: 0,
  class: "confirmed-notice-modal"
}
const _hoisted_62 = { class: "modal-body" }
const _hoisted_63 = {
  key: 0,
  class: "payroll-content"
}
const _hoisted_64 = { class: "payroll-grid" }
const _hoisted_65 = { class: "payroll-section" }
const _hoisted_66 = { class: "data-table" }
const _hoisted_67 = ["title"]
const _hoisted_68 = { class: "num" }
const _hoisted_69 = ["title"]
const _hoisted_70 = { class: "num" }
const _hoisted_71 = ["title"]
const _hoisted_72 = { class: "num" }
const _hoisted_73 = ["title"]
const _hoisted_74 = { class: "num" }
const _hoisted_75 = ["title"]
const _hoisted_76 = { class: "num" }
const _hoisted_77 = ["title"]
const _hoisted_78 = { class: "num" }
const _hoisted_79 = ["title"]
const _hoisted_80 = { class: "num" }
const _hoisted_81 = ["title"]
const _hoisted_82 = { class: "num" }
const _hoisted_83 = ["title"]
const _hoisted_84 = { class: "num" }
const _hoisted_85 = ["title"]
const _hoisted_86 = {
  key: 0,
  class: "badge warn"
}
const _hoisted_87 = ["title"]
const _hoisted_88 = {
  key: 0,
  class: "badge warn"
}
const _hoisted_89 = ["title"]
const _hoisted_90 = { class: "num" }
const _hoisted_91 = { class: "payroll-section" }
const _hoisted_92 = { class: "data-table" }
const _hoisted_93 = ["title"]
const _hoisted_94 = { class: "num" }
const _hoisted_95 = ["title"]
const _hoisted_96 = { class: "num" }
const _hoisted_97 = ["title"]
const _hoisted_98 = { class: "num" }
const _hoisted_99 = ["title"]
const _hoisted_100 = { class: "num" }
const _hoisted_101 = ["title"]
const _hoisted_102 = { class: "num" }
const _hoisted_103 = ["title"]
const _hoisted_104 = { class: "num" }
const _hoisted_105 = ["title"]
const _hoisted_106 = { class: "num" }
const _hoisted_107 = ["title"]
const _hoisted_108 = { class: "num" }
const _hoisted_109 = ["title"]
const _hoisted_110 = { class: "num" }
const _hoisted_111 = ["title"]
const _hoisted_112 = { class: "num" }
const _hoisted_113 = ["title"]
const _hoisted_114 = { class: "calc" }
const _hoisted_115 = { class: "amount" }
const _hoisted_116 = { class: "info-row" }
const _hoisted_117 = { class: "info-block" }
const _hoisted_118 = ["title"]
const _hoisted_119 = ["title"]
const _hoisted_120 = ["title"]
const _hoisted_121 = ["title"]
const _hoisted_122 = ["title"]
const _hoisted_123 = { class: "info-block" }
const _hoisted_124 = ["title"]
const _hoisted_125 = ["title"]
const _hoisted_126 = { class: "info-block" }
const _hoisted_127 = ["title"]
const _hoisted_128 = ["title"]
const _hoisted_129 = { class: "employee-info-section" }
const _hoisted_130 = { class: "info-grid" }
const _hoisted_131 = { class: "info-section" }
const _hoisted_132 = { class: "info-list" }
const _hoisted_133 = { class: "info-section" }
const _hoisted_134 = { class: "info-list" }
const _hoisted_135 = {
  key: 1,
  class: "info-item ok"
}
const _hoisted_136 = {
  key: 1,
  class: "services-content"
}
const _hoisted_137 = {
  key: 0,
  class: "data-table full sortable"
}
const _hoisted_138 = {
  key: 0,
  class: "badge red"
}
const _hoisted_139 = {
  key: 0,
  class: "badge blue"
}
const _hoisted_140 = { class: "r" }
const _hoisted_141 = {
  key: 1,
  class: "empty"
}
const _hoisted_142 = {
  key: 2,
  class: "sub-section"
}
const _hoisted_143 = { class: "sub-title" }
const _hoisted_144 = { class: "sub-total" }
const _hoisted_145 = { class: "data-table full" }
const _hoisted_146 = { class: "r" }
const _hoisted_147 = {
  key: 2,
  class: "weekly-content"
}
const _hoisted_148 = {
  key: 0,
  class: "data-table full"
}
const _hoisted_149 = ["rowspan"]
const _hoisted_150 = {
  key: 0,
  class: "badge red"
}
const _hoisted_151 = ["rowspan"]
const _hoisted_152 = {
  key: 1,
  class: "empty"
}
const _hoisted_153 = {
  key: 3,
  class: "calendar-content"
}
const _hoisted_154 = {
  key: 4,
  class: "settings-content"
}
const _hoisted_155 = { class: "settings-grid" }
const _hoisted_156 = { class: "settings-section" }
const _hoisted_157 = ["checked", "disabled"]
const _hoisted_158 = ["value", "disabled"]
const _hoisted_159 = ["checked", "disabled"]
const _hoisted_160 = { class: "checkbox-with-action" }
const _hoisted_161 = ["checked", "disabled"]
const _hoisted_162 = {
  key: 0,
  class: "badge-inline"
}
const _hoisted_163 = ["checked", "disabled"]
const _hoisted_164 = { class: "settings-section" }
const _hoisted_165 = ["checked", "disabled"]
const _hoisted_166 = ["checked", "disabled"]
const _hoisted_167 = ["checked", "disabled"]
const _hoisted_168 = { class: "input-row inline" }
const _hoisted_169 = ["value", "disabled"]
const _hoisted_170 = { class: "settings-section" }
const _hoisted_171 = { class: "input-row" }
const _hoisted_172 = ["value", "disabled"]
const _hoisted_173 = { class: "input-row" }
const _hoisted_174 = ["value", "disabled"]
const _hoisted_175 = { class: "input-row" }
const _hoisted_176 = ["value", "disabled", "placeholder"]
const _hoisted_177 = { class: "input-row" }
const _hoisted_178 = ["value", "disabled"]
const _hoisted_179 = {
  key: 0,
  class: "timepay-section"
}
const _hoisted_180 = { class: "data-table full" }
const _hoisted_181 = {
  key: 0,
  class: "badge holiday-badge"
}
const _hoisted_182 = { class: "service-count" }
const _hoisted_183 = ["onClick", "disabled"]
const _hoisted_184 = ["value", "onInput", "disabled"]
const _hoisted_185 = { class: "r total-amount" }
const _hoisted_186 = {
  key: 0,
  class: "holiday-allowance-info"
}
const _hoisted_187 = { class: "r total-amount" }
const _hoisted_188 = {
  key: 0,
  class: "holiday-allowance-info"
}
const _hoisted_189 = { class: "settings-actions" }
const _hoisted_190 = ["disabled"]
const _hoisted_191 = ["disabled"]
const _hoisted_192 = ["disabled"]
const _hoisted_193 = { key: 0 }
const _hoisted_194 = { key: 1 }
const _hoisted_195 = { class: "employee-info-section" }
const _hoisted_196 = { class: "info-grid" }
const _hoisted_197 = { class: "info-section" }
const _hoisted_198 = { class: "info-list" }
const _hoisted_199 = { class: "info-section" }
const _hoisted_200 = { class: "info-list" }
const _hoisted_201 = {
  key: 1,
  class: "info-item ok"
}

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import WageEmployeeCalendar from './WageEmployeeCalendar.vue';
import {
  shouldShowAdminDeductionTooltip,
  buildDeductionTooltip,
  buildCenterTooltip,
} from './payrollTooltipUtils';

interface Patient {
  patientCode: string;
  patientName: string;
  sugaCode: string;
  sugaName: string;
  sugaHours: number;
  sugaMinutesKey?: string | number | null;
  serviceDays: number;
  timePay?: string;
}

interface Employee {
  empCode: string;
  name: string;
  birth: string;
  workStartDate?: string;
  workEndDate?: string;
  patients: Patient[];
  totalSugaMoney: number;
  totalLunchTimeCount?: number;
}

interface Props {
  modelValue: boolean;
  employee: Employee | null;
  employees: Employee[];
  groupIndex: number;
  yearMonth?: string;
  sisulCode?: string;
  payrollDetail: any;
  settings: any;
  services: any[];
  weeklyServices: any[];
  severeCareItems: any[];
  severeCareDaily: any[];
  holidays: Record<string, string>;
  isConfirmed: boolean;
  centerProfit: number;
  cumulativeRetirement: number;
  retirementDetails?: { lemi_ym: string; retirement_amount: number }[];
  employeeInfoItems: { icon: string; color: string; text: string }[];
  restrictionItems: { icon: string; color: string; text: string }[];
  hasChanges?: boolean;
  isSaving?: boolean;
}

type ServiceSortKey = 'date' | 'patient' | 'time' | 'suga' | 'minutes' | 'money';

export default /*@__PURE__*/_defineComponent({
  __name: 'WageEmployeeModal',
  props: {
    modelValue: { type: Boolean },
    employee: {},
    employees: {},
    groupIndex: {},
    yearMonth: {},
    sisulCode: {},
    payrollDetail: {},
    settings: {},
    services: {},
    weeklyServices: { default: () => [] },
    severeCareItems: { default: () => [] },
    severeCareDaily: { default: () => [] },
    holidays: {},
    isConfirmed: { type: Boolean },
    centerProfit: { default: 0 },
    cumulativeRetirement: { default: 0 },
    retirementDetails: { default: () => [] },
    employeeInfoItems: { default: () => [] },
    restrictionItems: { default: () => [] },
    hasChanges: { type: Boolean, default: false },
    isSaving: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "update:groupIndex", "update-setting", "update-timepay", "open-bonin-modal", "open-employment-modal", "open-suga-hours-modal", "reset-settings", "save-settings", "load-previous-settings", "start-date-updated"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const currentIndex = computed({
  get: () => props.groupIndex,
  set: (value) => emit('update:groupIndex', value)
});

// 사원 선택 드롭다운용
const employeeOptions = computed(() => {
  return props.employees.map((emp, idx) => ({
    value: idx,
    text: emp.name || '-'
  }));
});

const selectedEmployeeValue = computed({
  get: () => currentIndex.value,
  set: (value) => {
    if (value !== null && value !== undefined) {
      currentIndex.value = value;
    }
  }
});

const onEmployeeSelect = (value: number | null) => {
  if (value !== null && value !== undefined && value !== currentIndex.value) {
    currentIndex.value = value;
  }
};

const activeTab = ref<'payroll' | 'settings' | 'calendar' | 'services' | 'weekly'>('payroll');
const showHelp = ref(false);

// 입사일·퇴사일 변경 모달
const showStartDateModal = ref(false);
const newStartDate = ref('');
const newEndDate = ref('');
const hasEndDate = ref(false);
const isSavingStartDate = ref(false);

const todayDate = computed(() => {
  const today = new Date();
  return today.toISOString().split('T')[0];
});

const formatDisplayDate = (dateStr: string | undefined): string => {
  if (!dateStr) return '';
  const cleaned = dateStr.replace(/[^0-9]/g, '');
  if (cleaned.length >= 8) {
    return `${cleaned.slice(0, 4)}-${cleaned.slice(4, 6)}-${cleaned.slice(6, 8)}`;
  } else if (cleaned.length >= 6) {
    return `${cleaned.slice(0, 4)}-${cleaned.slice(4, 6)}`;
  }
  return dateStr;
};

const openStartDateModal = () => {
  // 현재 입사일을 기본값으로 설정
  if (props.employee?.workStartDate) {
    const cleaned = props.employee.workStartDate.replace(/[^0-9]/g, '');
    if (cleaned.length >= 8) {
      newStartDate.value = `${cleaned.slice(0, 4)}-${cleaned.slice(4, 6)}-${cleaned.slice(6, 8)}`;
    }
  } else {
    newStartDate.value = '';
  }
  
  // 현재 퇴사일을 기본값으로 설정
  if (props.employee?.workEndDate) {
    const cleaned = props.employee.workEndDate.replace(/[^0-9]/g, '');
    if (cleaned.length >= 8) {
      newEndDate.value = `${cleaned.slice(0, 4)}-${cleaned.slice(4, 6)}-${cleaned.slice(6, 8)}`;
      hasEndDate.value = true;
    } else {
      newEndDate.value = '';
      hasEndDate.value = false;
    }
  } else {
    newEndDate.value = '';
    hasEndDate.value = false;
  }
  
  showStartDateModal.value = true;
};

const saveStartDate = async () => {
  if (!newStartDate.value || !props.employee) return;
  
  // props에서 sisulCode를 받거나, store에서 가져옴
  const sisulCode = props.sisulCode || store.state.user?.m_sisul_code;
  if (!sisulCode) {
    store.commit('showSnackbar', { text: '시설 정보를 찾을 수 없습니다.', color: 'error' });
    return;
  }
  
  isSavingStartDate.value = true;
  
  try {
    const response = await fetch('/api/emp/update-start-date', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        m_sisul_code: sisulCode,
        emp_name: props.employee.name,
        emp_birth: props.employee.birth,
        emp_in_date: newStartDate.value,
        emp_out_date: hasEndDate.value ? newEndDate.value : null
      })
    });
    
    const result = await response.json();
    
    if (result.success) {
      const message = hasEndDate.value 
        ? '입사일/퇴사일이 변경되었습니다.' 
        : '입사일이 변경되었습니다.';
      store.commit('showSnackbar', { text: message, color: 'success' });
      showStartDateModal.value = false;
      // 부모 컴포넌트에 입사일/퇴사일 변경 알림
      emit('start-date-updated', props.groupIndex, newStartDate.value, hasEndDate.value ? newEndDate.value : null);
    } else {
      store.commit('showSnackbar', { text: result.message || '변경에 실패했습니다.', color: 'error' });
    }
  } catch (error) {
    console.error('입사일/퇴사일 변경 오류:', error);
    store.commit('showSnackbar', { text: '변경 중 오류가 발생했습니다.', color: 'error' });
  } finally {
    isSavingStartDate.value = false;
  }
};

// 서비스내역 정렬
const serviceSortKey = ref<ServiceSortKey>('date');
const serviceSortAsc = ref(true);

const toggleServiceSort = (key: ServiceSortKey) => {
  if (serviceSortKey.value === key) {
    serviceSortAsc.value = !serviceSortAsc.value;
  } else {
    serviceSortKey.value = key;
    serviceSortAsc.value = true;
  }
};

const sortedServices = computed(() => {
  if (!props.services || props.services.length === 0) return [];
  
  const sorted = [...props.services].sort((a, b) => {
    let compareA: any, compareB: any;
    
    switch (serviceSortKey.value) {
      case 'date':
        compareA = a.service_date || '';
        compareB = b.service_date || '';
        break;
      case 'patient':
        compareA = a.patient_name || '';
        compareB = b.patient_name || '';
        break;
      case 'time':
        compareA = a.start_time || '';
        compareB = b.start_time || '';
        break;
      case 'suga':
        compareA = a.suga_name || '';
        compareB = b.suga_name || '';
        break;
      case 'minutes':
        compareA = a.service_minutes || 0;
        compareB = b.service_minutes || 0;
        break;
      case 'money':
        compareA = a.suga_money || 0;
        compareB = b.suga_money || 0;
        break;
      default:
        return 0;
    }
    
    if (compareA < compareB) return serviceSortAsc.value ? -1 : 1;
    if (compareA > compareB) return serviceSortAsc.value ? 1 : -1;
    return 0;
  });
  
  return sorted;
});

const navigateEmployee = (delta: number) => {
  const newIndex = currentIndex.value + delta;
  if (newIndex >= 0 && newIndex < props.employees.length) {
    currentIndex.value = newIndex;
  }
};

const employeeAge = computed(() => {
  if (!props.employee?.birth || !props.yearMonth) return 0;
  const birthStr = props.employee.birth.replace(/[^0-9]/g, '');
  const birthYear = birthStr.length === 8 ? parseInt(birthStr.slice(0, 4)) : parseInt('19' + birthStr.slice(0, 2));
  const birthMonth = parseInt(birthStr.slice(birthStr.length === 8 ? 4 : 2, birthStr.length === 8 ? 6 : 4));
  const year = parseInt(props.yearMonth.slice(0, 4));
  const month = parseInt(props.yearMonth.slice(4, 6));
  let age = year - birthYear;
  if (month < birthMonth) age--;
  return age;
});

const workPeriodText = computed(() => {
  if (!props.employee?.workStartDate || !props.yearMonth) return '-';
  const startStr = props.employee.workStartDate.replace(/[^0-9]/g, '');
  if (startStr.length < 6) return '-';
  const startYear = parseInt(startStr.slice(0, 4));
  const startMonth = parseInt(startStr.slice(4, 6));
  const year = parseInt(props.yearMonth.slice(0, 4));
  const month = parseInt(props.yearMonth.slice(4, 6));
  let years = year - startYear;
  let months = month - startMonth;
  if (months < 0) { years--; months += 12; }
  if (years > 0) return `${years}년 ${months}개월`;
  return `${months}개월`;
});

const severeCareDaily = computed(() => props.severeCareDaily || []);
const severeCareTotal = computed(() => severeCareDaily.value.reduce((sum, item) => sum + (parseFloat(item.suga_money) || 0), 0));
const hasFamilySuga = computed(() => props.employee?.patients?.some(p => p.sugaName?.includes('가족')));

const calendarServices = computed(() => {
  const services = props.services || [];
  const severeCareDaily = props.severeCareDaily || [];
  
  const normalServices = services.map((s: any) => ({
    date: s.service_date || s.date,
    patientName: s.patient_name || s.patientName,
    patientCode: s.patient_code || s.patientCode,
    sugaName: s.suga_name || s.sugaName,
    startTime: s.start_time || s.startTime,
    endTime: s.end_time || s.endTime,
    sugaMoney: s.suga_money || s.sugaMoney || 0,
    isFamily: (s.suga_name || s.sugaName)?.includes('가족') || false,
    isSevereCare: false
  }));
  
  const severeCareServices = severeCareDaily.map((s: any) => ({
    date: s.service_date || s.date,
    patientName: s.patient_name || s.patientName,
    patientCode: s.patient_code || s.patientCode,
    sugaName: s.suga_name || s.sugaName || '중증수급자 가산',
    startTime: s.start_time || s.startTime || '',
    endTime: s.end_time || s.endTime || '',
    sugaMoney: s.suga_money || s.sugaMoney || 0,
    isFamily: false,
    isSevereCare: true
  }));
  
  return [...normalServices, ...severeCareServices];
});

const isHoliday = (dateStr: string): boolean => {
  if (!dateStr) return false;
  const date = new Date(dateStr);
  if (date.getDay() === 0) return true;
  return !!props.holidays[dateStr];
};

const getSugaKey = (patient: Patient): string => {
  // StepThree.vue와 동일한 로직: 수가시간을 키에 포함하여 중복 카드 구분
  const hoursKey = patient.sugaHours ? `_h${patient.sugaHours}` : '';
  
  if (patient.sugaMinutesKey != null) {
    return `${patient.sugaCode}_${patient.sugaMinutesKey}${hoursKey}`;
  }
  return `${patient.sugaCode}${hoursKey}`;
};

// 270분초과 수가 여부 확인
const is270MinutesOverSuga = (patient: Patient): boolean => {
  return patient.sugaName?.includes('270분초과') || false;
};

// 환자별 수가시간 가져오기 (270분초과 수가는 30분 휴게시간 적용)
// 단, 8시간 이상 시에는 휴게시간 차감 없음
const getPatientSugaHours = (patient: Patient): number => {
  const baseHours = patient.sugaHours || 0;
  
  // 270분초과 수가인 경우 30분(0.5시간) 휴게시간 차감
  // 단, 8시간 이상 시에는 휴게시간 차감하지 않음
  if (is270MinutesOverSuga(patient)) {
    if (baseHours >= 8) {
      return baseHours; // 8시간 이상 시 휴게시간 차감 없음
    }
    return Math.max(0, baseHours - 0.5);
  }
  
  return baseHours;
};

// 수동 조정된 수가시간이 있으면 그 값을, 없으면 휴게시간 적용된 수가시간 반환
const getEffectiveSugaHours = (patient: Patient): number => {
  const sugaKey = getSugaKey(patient);
  const customHours = props.settings?.customSugaHours?.[patient.patientCode]?.[sugaKey];
  
  // 수동 조정된 값이 있으면 그대로 사용
  if (customHours !== undefined) {
    return customHours;
  }
  
  // 270분초과 수가인 경우 30분 휴게시간 적용
  return getPatientSugaHours(patient);
};

const getTimePay = (patient: Patient): string => props.settings?.timePays?.[patient.patientCode]?.[getSugaKey(patient)] || '';
const updateTimePay = (patient: Patient, value: string) => emit('update-timepay', props.groupIndex, patient.patientCode, getSugaKey(patient), value);
const updateSetting = (key: string, value: any) => emit('update-setting', props.groupIndex, key, value);

// 장기근속수당 입력 핸들러 - 값 입력 시 applyLongServicePay도 함께 업데이트
const handleLongServicePayInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, ''); // 숫자만 추출
  if (value.length > 9) value = value.slice(0, 9);
  
  const numericValue = parseInt(value) || 0;
  // 입력 중에는 숫자만 저장 (포맷팅은 blur에서)
  emit('update-setting', props.groupIndex, 'longServicePay', value);
  emit('update-setting', props.groupIndex, 'applyLongServicePay', numericValue > 0);
};

// 장기근속수당 blur 핸들러 - 포맷팅 적용
const handleLongServicePayBlur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, '');
  const numericValue = parseInt(value) || 0;
  const formattedValue = numericValue > 0 ? new Intl.NumberFormat('ko-KR').format(numericValue) : '';
  emit('update-setting', props.groupIndex, 'longServicePay', formattedValue);
  emit('update-setting', props.groupIndex, 'applyLongServicePay', numericValue > 0);
};

// 기타수당 입력 핸들러 - 값 입력 시 applyEtcAllowance도 함께 업데이트
const handleEtcAllowanceInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, '');
  if (value.length > 9) value = value.slice(0, 9);
  
  const numericValue = parseInt(value) || 0;
  emit('update-setting', props.groupIndex, 'etcAllowance', value);
  emit('update-setting', props.groupIndex, 'applyEtcAllowance', numericValue > 0);
};

// 기타수당 blur 핸들러 - 포맷팅 적용
const handleEtcAllowanceBlur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, '');
  const numericValue = parseInt(value) || 0;
  const formattedValue = numericValue > 0 ? new Intl.NumberFormat('ko-KR').format(numericValue) : '';
  emit('update-setting', props.groupIndex, 'etcAllowance', formattedValue);
  emit('update-setting', props.groupIndex, 'applyEtcAllowance', numericValue > 0);
};

// 보수교육비 입력 핸들러 - 값 입력 시 applyBosuEduPay도 함께 업데이트
const handleBosuEduPayInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, ''); // 숫자만 추출
  if (value.length > 9) value = value.slice(0, 9);
  
  const numericValue = parseInt(value) || 0;
  // 입력 중에는 숫자만 저장 (포맷팅은 blur에서)
  emit('update-setting', props.groupIndex, 'bosuEduPay', value);
  emit('update-setting', props.groupIndex, 'applyBosuEduPay', numericValue > 0);
};

// 보수교육비 blur 핸들러 - 포맷팅 적용
const handleBosuEduPayBlur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, '');
  const numericValue = parseInt(value) || 0;
  const formattedValue = numericValue > 0 ? new Intl.NumberFormat('ko-KR').format(numericValue) : '';
  emit('update-setting', props.groupIndex, 'bosuEduPay', formattedValue);
  emit('update-setting', props.groupIndex, 'applyBosuEduPay', numericValue > 0);
};

// 기타공제 입력 핸들러 - 값 입력 시 applyEmpEtc도 함께 업데이트
const handleEmpEtcInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, ''); // 숫자만 추출
  if (value.length > 9) value = value.slice(0, 9);
  
  const numericValue = parseInt(value) || 0;
  emit('update-setting', props.groupIndex, 'empEtc', value);
  emit('update-setting', props.groupIndex, 'applyEmpEtc', numericValue > 0);
};

// 기타공제 blur 핸들러 - 포맷팅 적용
const handleEmpEtcBlur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, '');
  const numericValue = parseInt(value) || 0;
  const formattedValue = numericValue > 0 ? new Intl.NumberFormat('ko-KR').format(numericValue) : '';
  emit('update-setting', props.groupIndex, 'empEtc', formattedValue);
  emit('update-setting', props.groupIndex, 'applyEmpEtc', numericValue > 0);
};

// 본인부담금 클릭 핸들러
const handleBoninPayClick = () => {
  if (props.isConfirmed) {
    store.commit('showSnackbar', { text: '마감된 급여는 수정할 수 없습니다.', color: 'warning' });
    return;
  }
  if (!hasFamilySuga.value) {
    store.commit('showSnackbar', { text: '본인부담금은 가족요양 서비스가 있는 경우에만 설정할 수 있습니다.', color: 'info' });
    return;
  }
  emit('open-bonin-modal', props.groupIndex);
};

const close = () => { dialogVisible.value = false; };
const formatMoney = (amount: number | string | undefined | null): string => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  return new Intl.NumberFormat('ko-KR').format(Math.round(num || 0));
};
const formatServiceDate = (date: string | undefined): string => {
  if (!date) return '-';
  return date.substring(5).replace('-', '/');
};
const formatMinutes = (minutes: number): string => {
  if (!minutes) return '0분';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h > 0 && m > 0) return `${h}시간 ${m}분`;
  if (h > 0) return `${h}시간`;
  return `${m}분`;
};

// 수가시간 표시 (커스텀 값이 있으면 커스텀 값, 없으면 휴게시간 적용된 값)
const getDisplaySugaHours = (patient: Patient): string => {
  const hours = getEffectiveSugaHours(patient);
  return hours.toFixed(1);
};

// 수가명이 공휴일가산인지 확인하는 함수
// '공휴일가산', '공휴일 가산', 또는 '공휴일'과 '가산'이 함께 포함된 경우
const isHolidaySuga = (sugaName: string | null | undefined): boolean => {
  if (!sugaName) return false;
  const name = sugaName.toLowerCase().replace(/\s/g, ''); // 공백 제거
  // '공휴일가산'이 포함되어 있거나, '공휴일'과 '가산'이 모두 포함된 경우
  if (name.includes('공휴일가산')) return true;
  if (name.includes('공휴일') && name.includes('가산')) return true;
  // '일요일가산'이 포함되어 있거나, '일요일'과 '가산'이 모두 포함된 경우
  if (name.includes('일요일가산')) return true;
  if (name.includes('일요일') && name.includes('가산')) return true;
  return false;
};

// 수급자별 휴일수당 계산 (총시간 × 최저시급 × 0.5)
const getPatientHolidayAllowance = (patient: Patient): number => {
  if (!isHolidaySuga(patient.sugaName)) return 0;
  
  const hours = getEffectiveSugaHours(patient);
  const serviceDays = patient.serviceDays || 0;
  const totalHours = serviceDays * hours;
  
  // 최저시급 사용 (급여정보 탭의 휴일수당 계산과 동일)
  const minWage = props.payrollDetail?.calcInfo?.minWage || 0;
  
  if (minWage === 0) return 0;
  
  return Math.round(totalHours * minWage * 0.5);
};

// 수급자별 기본금액 계산 (서비스횟수 × 수가시간 × 시급) - 휴일수당 미포함
const getPatientBaseAmount = (patient: Patient): number => {
  const hours = getEffectiveSugaHours(patient);
  const serviceDays = patient.serviceDays || 0;
  const timePay = getTimePay(patient);
  const timePayNum = timePay ? parseFloat(String(timePay).replace(/[^\d]/g, '')) || 0 : 0;
  
  // 시급이 입력되지 않은 경우 0 반환
  if (timePayNum === 0) return 0;
  
  return serviceDays * hours * timePayNum;
};

// 수급자별 합계금액 계산 (기본금액 + 휴일수당)
const getPatientTotalAmount = (patient: Patient): number => {
  const baseAmount = getPatientBaseAmount(patient);
  const holidayAllowance = props.settings?.applyHoliday ? getPatientHolidayAllowance(patient) : 0;
  return baseAmount + holidayAllowance;
};

// 전체 수급자 합계금액 (휴일수당 포함)
const getAllPatientsTotalAmount = (): number => {
  if (!props.employee?.patients) return 0;
  return props.employee.patients.reduce((sum, p) => sum + getPatientTotalAmount(p), 0);
};

// 전체 휴일수당 합계
const getTotalHolidayAllowance = (): number => {
  if (!props.employee?.patients) return 0;
  return props.employee.patients.reduce((sum, p) => sum + getPatientHolidayAllowance(p), 0);
};

const getPayrollTooltip = (field: string): string => {
  const payroll = props.payrollDetail;
  if (!payroll) return '';
  const fmt = (n: number) => new Intl.NumberFormat('ko-KR').format(Math.round(n || 0));
  const calcInfo = payroll.calcInfo || {};
  const minWage = calcInfo.minWage || 0;
  const totalSugaHours = calcInfo.totalSugaHours || 0;
  const annualLeaveDays = calcInfo.annualLeaveDays || 0;
  const workDaysForCalc = calcInfo.workDaysForCalc || 0;
  const totalMonthlyPay = calcInfo.totalMonthlyPay || 0;
  const baseVacationPay = calcInfo.baseVacationPay || 0;
  const remainingAmount = calcInfo.remainingAmount || 0;
  const vacationPayAddition = calcInfo.vacationPayAddition || 0;
  const yearLevel = calcInfo.yearLevel || 1;
  const totalMonthsWorked = calcInfo.totalMonthsWorked || 0;
  const mealAllowance = calcInfo.mealAllowance || 0;
  
  // 시급 역산 정보
  const wasWageAdjusted = calcInfo.wasWageAdjusted || false;
  const adjustedHourlyWage = calcInfo.adjustedHourlyWage || minWage;
  const adjustedBaseVacationPay = calcInfo.adjustedBaseVacationPay || 0;
  const vacationPayDifference = calcInfo.vacationPayDifference || 0;
  
  switch (field) {
    case 'basicPay': {
      if (wasWageAdjusted) {
        let tooltip = `[기본급 계산 - 시급 역산 적용]\n\n`;
        tooltip += `▶ 60시간 미만 시급 역산\n`;
        tooltip += `  합계금액: ${fmt(totalMonthlyPay)}원\n`;
        tooltip += `  수가시간: ${totalSugaHours.toFixed(1)}시간\n\n`;
        tooltip += `▶ 역산 시급 계산\n`;
        tooltip += `  이론적 최대 시급: ${fmt(totalMonthlyPay)}원 ÷ 1.2 ÷ ${totalSugaHours.toFixed(1)}시간\n`;
        tooltip += `  = ${fmt(Math.round(totalMonthlyPay / 1.2 / totalSugaHours))}원\n`;
        tooltip += `  → 10원 단위 내림: ${fmt(adjustedHourlyWage)}원\n\n`;
        tooltip += `▶ 기본급 계산\n`;
        tooltip += `  ${fmt(adjustedHourlyWage)}원 × ${totalSugaHours.toFixed(1)}시간 = ${fmt(payroll.basicPay || 0)}원\n\n`;
        tooltip += `※ 최저시급(${fmt(minWage)}원) 대비 +${fmt(adjustedHourlyWage - minWage)}원 조정`;
        return tooltip;
      }
      return `최저시급 × 수가시간 = ${fmt(minWage)}원 × ${totalSugaHours.toFixed(1)}시간 = ${fmt(payroll.basicPay || 0)}원`;
    }
    case 'holidayPay': {
      if (wasWageAdjusted) {
        let tooltip = `[주휴수당 계산 - 시급 역산 적용]\n\n`;
        tooltip += `▶ 조정된 기본급 기준\n`;
        tooltip += `  기본급: ${fmt(payroll.basicPay || 0)}원\n`;
        tooltip += `  주휴수당: ${fmt(payroll.basicPay || 0)}원 × 0.2 = ${fmt(payroll.holidayPay || 0)}원`;
        return tooltip;
      }
      return `기본급 × 0.2 = ${fmt(payroll.basicPay || 0)}원 × 0.2 = ${fmt(payroll.holidayPay || 0)}원`;
    }
    case 'vacationPay': {
      if (workDaysForCalc === 0) return '근무일수 정보 없음';
      
      const isUnder60Hours = calcInfo.isUnder60Hours || false;
      const wasVacationPayAdjusted = calcInfo.wasVacationPayAdjusted || false;
      const basicPlusHoliday = calcInfo.basicPlusHoliday || 0;
      
      let tooltip = `[연차수당 계산]\n\n`;
      
      // 60시간 미만 + 시급 역산 적용된 경우: 별도 처리
      if (isUnder60Hours && wasWageAdjusted) {
        tooltip += `━━━━━━━━━━━━━━━━━━━━\n`;
        tooltip += `⚠️ 월 60시간 미만 근무 (${totalSugaHours.toFixed(1)}시간)\n`;
        tooltip += `━━━━━━━━━━━━━━━━━━━━\n\n`;
        
        tooltip += `▶ 시급 역산 적용\n`;
        tooltip += `  수급자별 시급×수가시간 합계가 최저시급 기준\n`;
        tooltip += `  기본급+주휴수당+연차수당보다 높아 시급을 역산합니다.\n\n`;
        
        const vacationRatio = workDaysForCalc > 0 ? (annualLeaveDays / 12) / workDaysForCalc : 0;
        const totalRatio = 1 + 0.2 + vacationRatio;
        
        tooltip += `▶ 역산 시급 계산 (연차수당 포함)\n`;
        tooltip += `  합계금액: ${fmt(totalMonthlyPay)}원\n`;
        tooltip += `  비율: 1 + 0.2 + (${annualLeaveDays}일÷12÷${workDaysForCalc}일) = ${totalRatio.toFixed(4)}\n`;
        tooltip += `  이론적 시급: ${fmt(totalMonthlyPay)}원 ÷ ${totalSugaHours.toFixed(1)}h ÷ ${totalRatio.toFixed(4)}\n`;
        tooltip += `  → 10원 단위 내림: ${fmt(adjustedHourlyWage)}원\n\n`;
        
        tooltip += `▶ 역산 시급 기준 급여 (동일 시급 적용)\n`;
        tooltip += `  기본급: ${fmt(adjustedHourlyWage)}원 × ${totalSugaHours.toFixed(1)}h = ${fmt(payroll.basicPay || 0)}원\n`;
        tooltip += `  주휴수당: ${fmt(payroll.basicPay || 0)}원 × 0.2 = ${fmt(payroll.holidayPay || 0)}원\n`;
        tooltip += `  연차수당: (${fmt(adjustedHourlyWage)}원 × ${totalSugaHours.toFixed(1)}h ÷ ${workDaysForCalc}일) × ${annualLeaveDays}일 ÷ 12\n`;
        tooltip += `          = ${fmt(adjustedBaseVacationPay)}원\n\n`;
        
        tooltip += `▶ 합계 확인\n`;
        tooltip += `  기본급+주휴수당+연차수당: ${fmt(basicPlusHoliday + adjustedBaseVacationPay)}원\n`;
        tooltip += `  합계금액: ${fmt(totalMonthlyPay)}원\n`;
        
        if (vacationPayDifference > 0) {
          tooltip += `  → 차액: ${fmt(vacationPayDifference)}원 (연차수당에 추가)\n\n`;
          tooltip += `▶ 최종 연차수당\n`;
          tooltip += `  ${fmt(adjustedBaseVacationPay)}원 + ${fmt(vacationPayDifference)}원 = ${fmt(payroll.vacationPay || 0)}원`;
        } else {
          tooltip += `\n\n▶ 최종 연차수당: ${fmt(payroll.vacationPay || 0)}원`;
        }
        
        tooltip += `\n\n※ 60시간 미만 시 식대 미적용`;
        tooltip += `\n※ 최저시급(${fmt(minWage)}원) 대비 +${fmt(adjustedHourlyWage - minWage)}원 조정됨`;
      } else if (isUnder60Hours) {
        // 60시간 미만이지만 시급 역산 미적용
        tooltip += `━━━━━━━━━━━━━━━━━━━━\n`;
        tooltip += `⚠️ 월 60시간 미만 근무 (${totalSugaHours.toFixed(1)}시간)\n`;
        tooltip += `━━━━━━━━━━━━━━━━━━━━\n\n`;
        tooltip += `원칙적으로 60시간 미만 근무 시 연차수당은\n`;
        tooltip += `미지급이 원칙입니다.\n\n`;
        tooltip += `단, 수급자별 시급 및 수가시간으로 계산된\n`;
        tooltip += `합계금액(월급여)에 미달하는 경우,\n`;
        tooltip += `그 차액을 연차수당으로 지급합니다.\n\n`;
        
        // 연차일수 산정 기준
        tooltip += `▶ 연차일수 산정\n`;
        tooltip += `  근속기간: ${totalMonthsWorked}개월 → ${yearLevel}년차\n`;
        tooltip += `  연차일수: ${annualLeaveDays}일\n\n`;
        
        // 기본 연차수당 계산 (공식)
        tooltip += `▶ 기본 연차수당 (공식)\n`;
        tooltip += `  (최저시급 × 수가시간 ÷ 근무일수) × 연차일수 ÷ 12\n`;
        tooltip += `  = (${fmt(minWage)}원 × ${totalSugaHours.toFixed(1)}h ÷ ${workDaysForCalc}일) × ${annualLeaveDays}일 ÷ 12\n`;
        tooltip += `  = ${fmt(baseVacationPay)}원\n\n`;
        
        tooltip += `▶ 60시간 미만 조정\n`;
        tooltip += `  월급여(합계): ${fmt(totalMonthlyPay)}원\n`;
        tooltip += `  기본급+주휴수당: ${fmt(basicPlusHoliday)}원\n`;
        
        if (wasVacationPayAdjusted) {
          tooltip += `  → 기본급+주휴수당+연차수당(${fmt(baseVacationPay)}원)이\n`;
          tooltip += `     월급여를 초과하므로 연차수당 조정\n`;
          tooltip += `  → 조정된 연차수당: ${fmt(totalMonthlyPay)}원 - ${fmt(basicPlusHoliday)}원\n`;
          tooltip += `     = ${fmt(payroll.vacationPay || 0)}원\n\n`;
        } else if (basicPlusHoliday >= totalMonthlyPay) {
          tooltip += `  → 기본급+주휴수당이 이미 월급여 이상\n`;
          tooltip += `  → 연차수당: 0원\n\n`;
        } else {
          const diff = totalMonthlyPay - basicPlusHoliday;
          tooltip += `  → 여유금액: ${fmt(diff)}원\n`;
          tooltip += `  → 연차수당(${fmt(baseVacationPay)}원)이 여유금액 이내\n`;
          tooltip += `  → 연차수당 그대로 적용: ${fmt(payroll.vacationPay || 0)}원\n\n`;
        }
        
        tooltip += `▶ 최종 연차수당: ${fmt(payroll.vacationPay || 0)}원`;
        tooltip += `\n\n※ 60시간 미만 시 식대 미적용`;
      } else {
        // 60시간 이상: 기존 로직
        // 1. 연차일수 산정 기준
        tooltip += `▶ 연차일수 산정\n`;
        tooltip += `  근속기간: ${totalMonthsWorked}개월 → ${yearLevel}년차\n`;
        tooltip += `  연차일수: ${annualLeaveDays}일\n\n`;
        
        // 2. 기본 연차수당 계산 (공식)
        tooltip += `▶ 기본 연차수당 (공식)\n`;
        tooltip += `  (최저시급 × 수가시간 ÷ 근무일수) × 연차일수 ÷ 12\n`;
        tooltip += `  = (${fmt(minWage)}원 × ${totalSugaHours.toFixed(1)}h ÷ ${workDaysForCalc}일) × ${annualLeaveDays}일 ÷ 12\n`;
        tooltip += `  = ${fmt(baseVacationPay)}원\n\n`;
        
        // 3. 남은 금액 분배
        tooltip += `▶ 남은 금액 분배\n`;
        tooltip += `  월급여: ${fmt(totalMonthlyPay)}원\n`;
        tooltip += `  - 기본급: ${fmt(payroll.basicPay || 0)}원\n`;
        tooltip += `  - 주휴수당: ${fmt(payroll.holidayPay || 0)}원\n`;
        tooltip += `  - 기본 연차수당: ${fmt(baseVacationPay)}원\n`;
        tooltip += `  = 남은 금액: ${fmt(remainingAmount)}원\n\n`;
        
        // 4. 식대 적용 여부에 따른 처리
        if (mealAllowance > 0) {
          tooltip += `▶ 식대 차감 후 연차수당 가산\n`;
          tooltip += `  식대: ${fmt(mealAllowance)}원\n`;
          tooltip += `  연차수당 가산: ${fmt(vacationPayAddition)}원\n\n`;
        } else if (vacationPayAddition > 0) {
          tooltip += `▶ 남은 금액 전액 연차수당 가산\n`;
          tooltip += `  가산액: ${fmt(vacationPayAddition)}원\n\n`;
        }
        
        // 5. 최종 연차수당
        tooltip += `▶ 최종 연차수당\n`;
        tooltip += `  ${fmt(baseVacationPay)}원 + ${fmt(vacationPayAddition)}원 = ${fmt(payroll.vacationPay || 0)}원`;
      }
      
      return tooltip;
    }
    case 'familyBasicTotal':
      return '가족요양: 월급여 전체가 기본급으로 처리됩니다.';
    case 'mealAllowance':
      return '비과세 식대 (월 20만원 한도)';
    case 'longServicePay': {
      const longServicePayAmount = payroll.longServicePay || 0;
      if (longServicePayAmount === 0) {
        return '장기근속수당 미적용\n\n급여설정에서 장기근속수당을 입력하면 적용됩니다.';
      }
      
      let tooltip = '[장기근속수당]\n\n';
      tooltip += `▶ 설정 금액: ${fmt(longServicePayAmount)}원\n\n`;
      tooltip += `※ 급여설정에서 직접 입력한 금액입니다.\n`;
      tooltip += `※ 장기근속수당은 과세 대상입니다.`;
      
      return tooltip;
    }
    case 'etcAllowance': {
      const etcAllowanceAmount = payroll.etcAllowance || 0;
      if (etcAllowanceAmount === 0) {
        return '기타수당 미적용\n\n급여설정에서 기타수당을 입력하면 적용됩니다.';
      }
      
      let tooltip = '[기타수당]\n\n';
      tooltip += `▶ 설정 금액: ${fmt(etcAllowanceAmount)}원\n\n`;
      tooltip += `※ 급여설정에서 직접 입력한 금액입니다.\n`;
      tooltip += `※ 기타수당은 과세 대상입니다.`;
      
      return tooltip;
    }
    case 'bosuEduPay':
      return '보수교육 이수에 따른 수당';
    case 'severeCareAddition': {
      const dailyItems = props.severeCareDaily || [];
      if (dailyItems.length === 0) {
        return '중증수급자 가산 대상 없음';
      }
      
      let tooltip = '[중증수급자 가산 내역]\n\n';
      let total = 0;
      
      const patientGroups: Record<string, any[]> = {};
      dailyItems.forEach((item: any) => {
        const key = item.patient_name || '-';
        if (!patientGroups[key]) patientGroups[key] = [];
        patientGroups[key].push(item);
      });
      
      Object.entries(patientGroups).forEach(([patientName, items], groupIdx) => {
        let patientTotal = 0;
        tooltip += `▶ ${patientName}\n`;
        items.forEach((item: any) => {
          const date = item.service_date || '-';
          const dateStr = date.substring(5).replace('-', '/');
          const money = parseFloat(item.suga_money) || 0;
          patientTotal += money;
          tooltip += `   ${dateStr}: ${fmt(money)}원\n`;
        });
        total += patientTotal;
        tooltip += `   소계: ${fmt(patientTotal)}원 (${items.length}회)\n`;
        if (groupIdx < Object.keys(patientGroups).length - 1) tooltip += '\n';
      });
      
      tooltip += '\n────────────\n';
      tooltip += `합계: ${fmt(total)}원`;
      
      return tooltip;
    }
    case 'holidayAllowance': {
      if (!props.settings?.applyHoliday) {
        return '⚠️ 휴일수당 미적용 설정됨\n급여설정 탭에서 "휴일수당" 체크박스를 활성화하면 적용됩니다.';
      }
      const holidayMinutes = calcInfo.holidayMinutes || 0;
      const holidayHours = Math.round(holidayMinutes / 60 * 10) / 10;
      if ((payroll.holidayAllowance || 0) === 0) {
        return '휴일가산 수가 없음';
      }
      let tooltip = '[휴일수당 계산]\n\n';
      tooltip += `▶ 휴일가산 수가시간: ${holidayHours}시간 (${fmt(holidayMinutes)}분)\n`;
      tooltip += `▶ 최저시급: ${fmt(minWage)}원\n`;
      tooltip += `▶ 가산율: 0.5 (50%)\n\n`;
      tooltip += `────────────\n`;
      tooltip += `${holidayHours}시간 × ${fmt(minWage)}원 × 0.5 = ${fmt(payroll.holidayAllowance)}원\n\n`;
      tooltip += `※ 수가명에 "공휴일가산" 또는 "일요일가산"이 포함된 서비스만 대상`;
      return tooltip;
    }
    case 'overtimeAllowance': {
      if (!props.settings?.applyOvertime) {
        return '⚠️ 연장수당 미적용 설정됨\n급여설정 탭에서 "연장수당" 체크박스를 활성화하면 적용됩니다.';
      }
      const overtimeMinutes = calcInfo.overtimeMinutes || 0;
      const overtimeHours = Math.round(overtimeMinutes / 60 * 10) / 10;
      if ((payroll.overtimeAllowance || 0) === 0) {
        return '연장근무 없음';
      }
      let tooltip = '[연장수당 계산]\n\n';
      tooltip += `▶ 연장근무시간: ${overtimeHours}시간 (${fmt(overtimeMinutes)}분)\n`;
      tooltip += `▶ 최저시급: ${fmt(minWage)}원\n`;
      tooltip += `▶ 가산율: 0.5 (50%)\n\n`;
      tooltip += `────────────\n`;
      tooltip += `${overtimeHours}시간 × ${fmt(minWage)}원 × 0.5 = ${fmt(payroll.overtimeAllowance)}원\n\n`;
      tooltip += `※ 일 8시간 초과 근무 시간 기준`;
      return tooltip;
    }
    case 'totalPay':
      return `기본급 + 주휴수당 + 연차수당 + 기타수당 = ${fmt(payroll.totalPay || 0)}원`;
    case 'netPay':
      return `지급 합계(${fmt(payroll.totalPay || 0)}원) - 공제 합계(${fmt(payroll.totalEmployeeDeduction || 0)}원) = ${fmt(payroll.netPay || 0)}원`;
    default: 
      return '';
  }
};

const showAdminDeductionTooltip = computed(() =>
  shouldShowAdminDeductionTooltip(store.getters.isAdmin, store.getters.isImpersonating)
);

const deductionTooltip = (field: string): string => {
  if (!showAdminDeductionTooltip.value) return '';
  return buildDeductionTooltip(field, props.payrollDetail, props.settings);
};

const centerTooltip = (field: string): string => {
  if (!showAdminDeductionTooltip.value) return '';
  return buildCenterTooltip(field, props.payrollDetail, props.settings);
};

const getTaxTooltip = (field: string): string => {
  const payroll = props.payrollDetail;
  if (!payroll) return '';
  const fmt = (n: number) => new Intl.NumberFormat('ko-KR').format(Math.round(n || 0));
  
  switch (field) {
    case 'taxable':
      return `과세 대상 금액 (소득세 계산 기준) = ${fmt(payroll.taxableAmount || 0)}원`;
    case 'nonTaxable':
      return `비과세 금액 (식대 등) = ${fmt(payroll.nonTaxableAmount || 0)}원`;
    default:
      return '';
  }
};

const getProfitTooltip = (): string => {
  const payroll = props.payrollDetail;
  if (!payroll) return '';
  const fmt = (n: number) => new Intl.NumberFormat('ko-KR').format(Math.round(n || 0));
  const totalSuga = (props.employee?.totalSugaMoney || 0) + (payroll.severeCareAddition || 0);
  const totalPay = payroll.totalPay || 0;
  const centerDeduction = payroll.totalCenterDeduction || 0;
  
  return `총수가(${fmt(totalSuga)}원) - 직원지급액(${fmt(totalPay)}원) - 기관부담금(${fmt(centerDeduction)}원) = ${fmt(props.centerProfit || 0)}원`;
};

const getRetirementTooltip = (): string => {
  const fmt = (n: number) => new Intl.NumberFormat('ko-KR').format(Math.round(n));
  const details = props.retirementDetails || [];
  
  if (details.length === 0) {
    return '입사 이후 누적된 퇴직금 총액';
  }
  
  // 년월을 YYYY-MM 형식으로 변환
  const formatYm = (ym: string) => {
    if (ym.length === 6) {
      return `${ym.substring(0, 4)}-${ym.substring(4, 6)}`;
    }
    return ym;
  };
  
  let tooltip = '[월별 퇴직금 적립 내역]\n';
  let total = 0;
  
  details.forEach((item) => {
    const amount = Number(item.retirement_amount) || 0;
    total += amount;
    tooltip += `${formatYm(item.lemi_ym)}: ${fmt(amount)}원\n`;
  });
  
  tooltip += `────────────\n`;
  tooltip += `합계: ${fmt(total)}원`;
  
  return tooltip;
};

watch(dialogVisible, (visible) => { if (visible) activeTab.value = 'payroll'; });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((dialogVisible).value = $event)),
    "max-width": "880px",
    scrollable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "wage-modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (__props.employees.length > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(currentIndex.value + 1) + "/" + _toDisplayString(__props.employees.length), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (__props.employees.length > 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "nav-btn prev",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateEmployee(-1))),
                      disabled: currentIndex.value <= 0
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                          _createTextVNode("mdi-chevron-left", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_5))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_autocomplete, {
                  modelValue: selectedEmployeeValue.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((selectedEmployeeValue).value = $event)),
                    onEmployeeSelect
                  ],
                  items: employeeOptions.value,
                  "item-title": "text",
                  "item-value": "value",
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  class: "emp-select"
                }, null, 8, ["modelValue", "items"]),
                (__props.employees.length > 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "nav-btn next",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateEmployee(1))),
                      disabled: currentIndex.value >= __props.employees.length - 1
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                          _createTextVNode("mdi-chevron-right", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              (__props.payrollDetail?.isFamilyOnlyCaregiver)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "가족요양"))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_8, "만 " + _toDisplayString(employeeAge.value) + "세 · 근속 " + _toDisplayString(workPeriodText.value), 1),
              _createElementVNode("button", {
                class: "edit-start-date-btn",
                onClick: openStartDateModal,
                title: "입사일·퇴사일 변경"
              }, [
                _createVNode(_component_v_icon, { size: "14" }, {
                  default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                    _createTextVNode("mdi-calendar-edit", -1)
                  ]))]),
                  _: 1
                }),
                _cache[47] || (_cache[47] = _createTextVNode(" 입사일·퇴사일 ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "help-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showHelp.value = true)),
                title: "도움말"
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                    _createTextVNode("mdi-help", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: close
              }, "×")
            ])
          ]),
          _createVNode(_component_v_dialog, {
            modelValue: showHelp.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showHelp).value = $event)),
            "max-width": "680px",
            class: "help-dialog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "help-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_v_icon, { size: "24" }, {
                        default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                          _createTextVNode("mdi-help-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[50] || (_cache[50] = _createTextVNode(" 사용 방법 안내 ", -1))
                    ]),
                    _createElementVNode("button", {
                      class: "help-close",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showHelp.value = false))
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                              _createTextVNode("mdi-account-switch", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[52] || (_cache[52] = _createTextVNode(" 다른 직원 보는 방법 ", -1))
                      ]),
                      _cache[53] || (_cache[53] = _createElementVNode("div", { class: "section-content" }, [
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "1"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 화면 왼쪽 위의 "),
                            _createElementVNode("strong", null, "◀ ▶ 화살표 버튼"),
                            _createTextVNode("을 누르면 이전/다음 직원으로 넘어가요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "2"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 또는 "),
                            _createElementVNode("strong", null, "이름이 적힌 칸"),
                            _createTextVNode("을 누르면 직원 목록이 나와요. 원하는 직원 이름을 선택하세요. ")
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                              _createTextVNode("mdi-tab", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[55] || (_cache[55] = _createTextVNode(" 화면 위쪽 메뉴(탭) 사용법 ", -1))
                      ]),
                      _cache[56] || (_cache[56] = _createElementVNode("div", { class: "section-content" }, [
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label" }, "급여정보"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 이 직원이 "),
                            _createElementVNode("strong", null, "얼마를 받는지"),
                            _createTextVNode(", "),
                            _createElementVNode("strong", null, "얼마가 빠지는지"),
                            _createTextVNode(" 확인하는 화면이에요. "),
                            _createElementVNode("div", { class: "step-tip" }, "💡 금액에 마우스를 올리면 어떻게 계산됐는지 나와요!")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label" }, "급여설정"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 4대보험, 수당, 시급 등을 "),
                            _createElementVNode("strong", null, "설정하고 변경"),
                            _createTextVNode("하는 화면이에요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label" }, "근무달력"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createElementVNode("strong", null, "달력 모양"),
                            _createTextVNode("으로 이 직원이 언제 일했는지 볼 수 있어요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label" }, "서비스내역"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 이 직원이 한 달 동안 "),
                            _createElementVNode("strong", null, "어떤 서비스를 했는지"),
                            _createTextVNode(" 목록으로 볼 수 있어요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label" }, "주차별근무"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createElementVNode("strong", null, "1주차, 2주차..."),
                            _createTextVNode(" 이렇게 주 단위로 근무시간을 볼 수 있어요. ")
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                              _createTextVNode("mdi-cog", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[58] || (_cache[58] = _createTextVNode(" 급여설정 화면 사용법 ", -1))
                      ]),
                      _cache[59] || (_cache[59] = _createElementVNode("div", { class: "section-content" }, [
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "1"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createElementVNode("strong", null, "체크박스(□)"),
                            _createTextVNode("를 눌러서 적용할 항목을 선택하세요."),
                            _createElementVNode("br"),
                            _createTextVNode(" 체크(✓)하면 적용, 체크 해제하면 미적용이에요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "2"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createElementVNode("strong", null, "금액 입력칸"),
                            _createTextVNode("에 숫자를 직접 입력할 수 있어요."),
                            _createElementVNode("br"),
                            _createTextVNode(" (예: 장기근속수당에 50000 입력) ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "3"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createElementVNode("strong", null, "시급"),
                            _createTextVNode("은 아래쪽 표에서 수급자별로 따로 입력할 수 있어요."),
                            _createElementVNode("br"),
                            _createTextVNode(" 비워두면 자동으로 최저시급이 적용돼요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step highlight-step" }, [
                          _createElementVNode("div", { class: "step-num important" }, "!"),
                          _createElementVNode("div", { class: "step-content important-text" }, [
                            _createTextVNode(" 설정을 바꾸면 "),
                            _createElementVNode("strong", null, "'저장' 버튼이 빨간색"),
                            _createTextVNode("으로 변해요."),
                            _createElementVNode("br"),
                            _createElementVNode("strong", null, "반드시 '저장' 버튼을 눌러야"),
                            _createTextVNode(" 변경 내용이 저장돼요! ")
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                              _createTextVNode("mdi-gesture-tap-button", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[61] || (_cache[61] = _createTextVNode(" 버튼 사용법 ", -1))
                      ]),
                      _cache[62] || (_cache[62] = _createElementVNode("div", { class: "section-content" }, [
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label blue" }, "과거정보 가져오기"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 누르면 "),
                            _createElementVNode("strong", null, "지난달 설정을 그대로 가져와요"),
                            _createTextVNode("."),
                            _createElementVNode("br"),
                            _createTextVNode(" 가져온 후에 '저장' 버튼을 눌러야 적용돼요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label gray" }, "되돌리기"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 실수로 잘못 바꿨을 때, 누르면 "),
                            _createElementVNode("strong", null, "바꾸기 전 상태로 돌아가요"),
                            _createTextVNode(". ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label dark" }, "저장"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 설정을 바꾼 후 "),
                            _createElementVNode("strong", null, "이 버튼을 꼭 눌러야 저장"),
                            _createTextVNode("돼요."),
                            _createElementVNode("br"),
                            _createTextVNode(" 버튼이 빨간색이면 \"아직 저장 안 됐어요!\"라는 뜻이에요. ")
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                              _createTextVNode("mdi-calendar-edit", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[64] || (_cache[64] = _createTextVNode(" 입사일·퇴사일 변경 방법 ", -1))
                      ]),
                      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "section-content" }, [
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "1"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 화면 왼쪽 위의 "),
                            _createElementVNode("strong", null, "'입사일·퇴사일' 버튼"),
                            _createTextVNode("을 누르세요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "2"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 새 창에서 "),
                            _createElementVNode("strong", null, "입사일"),
                            _createTextVNode("을 변경하거나, "),
                            _createElementVNode("strong", null, "'퇴사 처리'"),
                            _createTextVNode(" 체크 후 퇴사일을 선택하세요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "3"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createElementVNode("strong", null, "'변경' 버튼"),
                            _createTextVNode("을 눌러 저장하세요. "),
                            _createElementVNode("div", { class: "step-tip" }, "⚠️ 입사일/퇴사일 변경 시 근속연수와 연차수당 계산에 영향을 줍니다!")
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                              _createTextVNode("mdi-clock-alert", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[67] || (_cache[67] = _createTextVNode(" 270분초과 수가 휴게시간 안내 ", -1))
                      ]),
                      _cache[68] || (_cache[68] = _createElementVNode("div", { class: "section-content" }, [
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label" }, "270분초과"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 270분초과 수가의 경우 "),
                            _createElementVNode("strong", null, "30분 휴게시간이 자동 차감"),
                            _createTextVNode("됩니다."),
                            _createElementVNode("br"),
                            _createTextVNode(" (예: 5시간 → 4.5시간으로 계산) ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-label" }, "8시간 이상"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 단, "),
                            _createElementVNode("strong", null, "8시간 이상"),
                            _createTextVNode("인 경우에는 휴게시간이 "),
                            _createElementVNode("strong", null, "차감되지 않습니다"),
                            _createTextVNode(". "),
                            _createElementVNode("div", { class: "step-tip" }, "💡 수가시간 버튼을 클릭하면 수동으로 시간을 조정할 수 있어요!")
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                              _createTextVNode("mdi-percent", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[70] || (_cache[70] = _createTextVNode(" 본인부담금 설정 방법 (가족요양만 해당) ", -1))
                      ]),
                      _cache[71] || (_cache[71] = _createElementVNode("div", { class: "section-content" }, [
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "1"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 급여설정 탭에서 "),
                            _createElementVNode("strong", null, "'본인부담금' 입력칸"),
                            _createTextVNode("을 누르세요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "2"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 새 창이 뜨면 "),
                            _createElementVNode("strong", null, "원하는 비율(%)을 선택"),
                            _createTextVNode("하세요. ")
                          ])
                        ]),
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-num" }, "3"),
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 선택 후 "),
                            _createElementVNode("strong", null, "'저장' 버튼"),
                            _createTextVNode("을 눌러 저장하세요. ")
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                              _createTextVNode("mdi-close-circle", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[73] || (_cache[73] = _createTextVNode(" 창 닫는 방법 ", -1))
                      ]),
                      _cache[74] || (_cache[74] = _createElementVNode("div", { class: "section-content" }, [
                        _createElementVNode("div", { class: "help-step" }, [
                          _createElementVNode("div", { class: "step-content" }, [
                            _createTextVNode(" 오른쪽 위의 "),
                            _createElementVNode("strong", null, "× 버튼"),
                            _createTextVNode("을 누르면 이 창이 닫혀요. ")
                          ])
                        ])
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("button", {
                      class: "help-close-btn",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showHelp.value = false))
                    }, "닫기")
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_dialog, {
            modelValue: showStartDateModal.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showStartDateModal).value = $event)),
            "max-width": "400px",
            class: "start-date-dialog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "start-date-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_v_icon, { size: "20" }, {
                        default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                          _createTextVNode("mdi-calendar-edit", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[76] || (_cache[76] = _createTextVNode(" 입사일·퇴사일 변경 ", -1))
                    ]),
                    _createElementVNode("button", {
                      class: "start-date-close",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (showStartDateModal.value = false))
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _cache[77] || (_cache[77] = _createElementVNode("span", { class: "label" }, "직원명", -1)),
                      _createElementVNode("span", _hoisted_42, _toDisplayString(__props.employee?.name || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                            _createTextVNode("mdi-calendar-arrow-right", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[79] || (_cache[79] = _createTextVNode(" 입사일 ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _cache[80] || (_cache[80] = _createElementVNode("span", { class: "label" }, "현재", -1)),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(formatDisplayDate(__props.employee?.workStartDate) || '미등록'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _cache[81] || (_cache[81] = _createElementVNode("span", { class: "label" }, "변경", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newStartDate).value = $event)),
                          class: "date-input",
                          max: newEndDate.value || todayDate.value
                        }, null, 8, _hoisted_48), [
                          [_vModelText, newStartDate.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                            _createTextVNode("mdi-calendar-arrow-left", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[83] || (_cache[83] = _createTextVNode(" 퇴사일 ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _cache[84] || (_cache[84] = _createElementVNode("span", { class: "label" }, "현재", -1)),
                        _createElementVNode("span", _hoisted_52, _toDisplayString(formatDisplayDate(__props.employee?.workEndDate) || '재직중'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _cache[86] || (_cache[86] = _createElementVNode("span", { class: "label" }, "변경", -1)),
                        _createElementVNode("div", _hoisted_54, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newEndDate).value = $event)),
                            class: "date-input",
                            min: newStartDate.value,
                            max: todayDate.value,
                            disabled: !hasEndDate.value
                          }, null, 8, _hoisted_55), [
                            [_vModelText, newEndDate.value]
                          ]),
                          _createElementVNode("label", _hoisted_56, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((hasEndDate).value = $event))
                            }, null, 512), [
                              [_vModelCheckbox, hasEndDate.value]
                            ]),
                            _cache[85] || (_cache[85] = _createElementVNode("span", null, "퇴사 처리", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode(_component_v_icon, {
                        size: "14",
                        color: "#f59e0b"
                      }, {
                        default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                          _createTextVNode("mdi-alert", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[88] || (_cache[88] = _createTextVNode(" 입사일/퇴사일 변경 시 근속연수와 연차수당 계산에 영향을 줍니다. ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("button", {
                      class: "cancel-btn",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (showStartDateModal.value = false))
                    }, "취소"),
                    _createElementVNode("button", {
                      class: "save-btn",
                      onClick: saveStartDate,
                      disabled: !newStartDate.value || isSavingStartDate.value
                    }, _toDisplayString(isSavingStartDate.value ? '저장 중...' : '변경'), 9, _hoisted_59)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("button", {
              class: _normalizeClass({ active: activeTab.value === 'payroll' }),
              onClick: _cache[13] || (_cache[13] = ($event: any) => (activeTab.value = 'payroll'))
            }, "급여정보", 2),
            _createElementVNode("button", {
              class: _normalizeClass({ active: activeTab.value === 'settings' }),
              onClick: _cache[14] || (_cache[14] = ($event: any) => (activeTab.value = 'settings'))
            }, "급여설정", 2),
            _createElementVNode("button", {
              class: _normalizeClass({ active: activeTab.value === 'calendar' }),
              onClick: _cache[15] || (_cache[15] = ($event: any) => (activeTab.value = 'calendar'))
            }, "근무달력", 2),
            _createElementVNode("button", {
              class: _normalizeClass({ active: activeTab.value === 'services' }),
              onClick: _cache[16] || (_cache[16] = ($event: any) => (activeTab.value = 'services'))
            }, "서비스내역", 2),
            _createElementVNode("button", {
              class: _normalizeClass({ active: activeTab.value === 'weekly' }),
              onClick: _cache[17] || (_cache[17] = ($event: any) => (activeTab.value = 'weekly'))
            }, "주차별근무", 2)
          ]),
          (__props.isConfirmed && activeTab.value === 'settings')
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "#f59e0b"
                }, {
                  default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                    _createTextVNode("mdi-lock", -1)
                  ]))]),
                  _: 1
                }),
                _cache[90] || (_cache[90] = _createElementVNode("span", { class: "notice-text" }, [
                  _createTextVNode(" 급여가 "),
                  _createElementVNode("strong", null, "확정"),
                  _createTextVNode("되어 수정할 수 없습니다. 수정하려면 "),
                  _createElementVNode("strong", null, "확정 해제"),
                  _createTextVNode(" 후 진행해주세요. ")
                ], -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_62, [
            (activeTab.value === 'payroll' && __props.payrollDetail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _cache[103] || (_cache[103] = _createElementVNode("div", { class: "section-head" }, "지급", -1)),
                      _createElementVNode("table", _hoisted_66, [
                        _createElementVNode("tbody", null, [
                          (__props.payrollDetail.isFamilyOnlyCaregiver)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 0,
                                class: "has-tooltip",
                                title: getPayrollTooltip('familyBasicTotal')
                              }, [
                                _cache[91] || (_cache[91] = _createElementVNode("td", null, "기본급 (주휴·연차 포함)", -1)),
                                _createElementVNode("td", _hoisted_68, _toDisplayString(formatMoney(__props.payrollDetail.basicTotal)), 1)
                              ], 8, _hoisted_67))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("tr", {
                                  class: "has-tooltip",
                                  title: getPayrollTooltip('basicPay')
                                }, [
                                  _cache[92] || (_cache[92] = _createElementVNode("td", null, "기본급", -1)),
                                  _createElementVNode("td", _hoisted_70, _toDisplayString(formatMoney(__props.payrollDetail.basicPay)), 1)
                                ], 8, _hoisted_69),
                                _createElementVNode("tr", {
                                  class: "has-tooltip",
                                  title: getPayrollTooltip('holidayPay')
                                }, [
                                  _cache[93] || (_cache[93] = _createElementVNode("td", null, "주휴수당", -1)),
                                  _createElementVNode("td", _hoisted_72, _toDisplayString(formatMoney(__props.payrollDetail.holidayPay)), 1)
                                ], 8, _hoisted_71),
                                _createElementVNode("tr", {
                                  class: "has-tooltip",
                                  title: getPayrollTooltip('vacationPay')
                                }, [
                                  _cache[94] || (_cache[94] = _createElementVNode("td", null, "연차수당", -1)),
                                  _createElementVNode("td", _hoisted_74, _toDisplayString(formatMoney(__props.payrollDetail.vacationPay)), 1)
                                ], 8, _hoisted_73),
                                (__props.payrollDetail.mealAllowance > 0)
                                  ? (_openBlock(), _createElementBlock("tr", {
                                      key: 0,
                                      class: "has-tooltip",
                                      title: getPayrollTooltip('mealAllowance')
                                    }, [
                                      _cache[95] || (_cache[95] = _createElementVNode("td", null, "식대", -1)),
                                      _createElementVNode("td", _hoisted_76, _toDisplayString(formatMoney(__props.payrollDetail.mealAllowance)), 1)
                                    ], 8, _hoisted_75))
                                  : _createCommentVNode("", true)
                              ], 64)),
                          (__props.payrollDetail.longServicePay > 0)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 2,
                                class: "has-tooltip",
                                title: getPayrollTooltip('longServicePay')
                              }, [
                                _cache[96] || (_cache[96] = _createElementVNode("td", null, "장기근속수당", -1)),
                                _createElementVNode("td", _hoisted_78, _toDisplayString(formatMoney(__props.payrollDetail.longServicePay)), 1)
                              ], 8, _hoisted_77))
                            : _createCommentVNode("", true),
                          (__props.payrollDetail.etcAllowance > 0)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 3,
                                class: "has-tooltip",
                                title: getPayrollTooltip('etcAllowance')
                              }, [
                                _cache[97] || (_cache[97] = _createElementVNode("td", null, "기타수당", -1)),
                                _createElementVNode("td", _hoisted_80, _toDisplayString(formatMoney(__props.payrollDetail.etcAllowance)), 1)
                              ], 8, _hoisted_79))
                            : _createCommentVNode("", true),
                          (__props.payrollDetail.bosuEduPay > 0)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 4,
                                class: "has-tooltip",
                                title: getPayrollTooltip('bosuEduPay')
                              }, [
                                _cache[98] || (_cache[98] = _createElementVNode("td", null, "보수교육비", -1)),
                                _createElementVNode("td", _hoisted_82, _toDisplayString(formatMoney(__props.payrollDetail.bosuEduPay)), 1)
                              ], 8, _hoisted_81))
                            : _createCommentVNode("", true),
                          (__props.payrollDetail.severeCareAddition > 0)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 5,
                                class: "has-tooltip",
                                title: getPayrollTooltip('severeCareAddition')
                              }, [
                                _cache[99] || (_cache[99] = _createElementVNode("td", null, "중증수급자가산", -1)),
                                _createElementVNode("td", _hoisted_84, _toDisplayString(formatMoney(__props.payrollDetail.severeCareAddition)), 1)
                              ], 8, _hoisted_83))
                            : _createCommentVNode("", true),
                          (__props.payrollDetail.holidayAllowance > 0 || (!__props.settings?.applyHoliday && __props.payrollDetail.calcInfo?.hasHolidayWork))
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 6,
                                class: "has-tooltip",
                                title: getPayrollTooltip('holidayAllowance')
                              }, [
                                _createElementVNode("td", null, [
                                  _cache[100] || (_cache[100] = _createTextVNode(" 휴일수당 ", -1)),
                                  (!__props.settings?.applyHoliday && __props.payrollDetail.calcInfo?.hasHolidayWork)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_86, "미적용"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["num", { 'text-muted': !__props.settings?.applyHoliday }])
                                }, _toDisplayString(formatMoney(__props.payrollDetail.holidayAllowance)), 3)
                              ], 8, _hoisted_85))
                            : _createCommentVNode("", true),
                          (__props.payrollDetail.overtimeAllowance > 0 || (!__props.settings?.applyOvertime && __props.payrollDetail.calcInfo?.hasOvertimeWork))
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 7,
                                class: "has-tooltip",
                                title: getPayrollTooltip('overtimeAllowance')
                              }, [
                                _createElementVNode("td", null, [
                                  _cache[101] || (_cache[101] = _createTextVNode(" 연장수당 ", -1)),
                                  (!__props.settings?.applyOvertime && __props.payrollDetail.calcInfo?.hasOvertimeWork)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_88, "미적용"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["num", { 'text-muted': !__props.settings?.applyOvertime }])
                                }, _toDisplayString(formatMoney(__props.payrollDetail.overtimeAllowance)), 3)
                              ], 8, _hoisted_87))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("tfoot", null, [
                          _createElementVNode("tr", {
                            class: "has-tooltip",
                            title: getPayrollTooltip('totalPay')
                          }, [
                            _cache[102] || (_cache[102] = _createElementVNode("td", null, "지급 합계", -1)),
                            _createElementVNode("td", _hoisted_90, _toDisplayString(formatMoney(__props.payrollDetail.totalPay)), 1)
                          ], 8, _hoisted_89)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _cache[114] || (_cache[114] = _createElementVNode("div", { class: "section-head" }, "공제", -1)),
                      _createElementVNode("table", _hoisted_92, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", {
                            class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                            title: deductionTooltip('nationalPension')
                          }, [
                            _cache[104] || (_cache[104] = _createElementVNode("td", null, "국민연금", -1)),
                            _createElementVNode("td", _hoisted_94, _toDisplayString(formatMoney(__props.payrollDetail.employeeDeductions?.nationalPension || 0)), 1)
                          ], 10, _hoisted_93),
                          _createElementVNode("tr", {
                            class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                            title: deductionTooltip('healthInsurance')
                          }, [
                            _cache[105] || (_cache[105] = _createElementVNode("td", null, "건강보험", -1)),
                            _createElementVNode("td", _hoisted_96, _toDisplayString(formatMoney(__props.payrollDetail.employeeDeductions?.healthInsurance || 0)), 1)
                          ], 10, _hoisted_95),
                          _createElementVNode("tr", {
                            class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                            title: deductionTooltip('longTermCare')
                          }, [
                            _cache[106] || (_cache[106] = _createElementVNode("td", null, "장기요양", -1)),
                            _createElementVNode("td", _hoisted_98, _toDisplayString(formatMoney(__props.payrollDetail.employeeDeductions?.longTermCare || 0)), 1)
                          ], 10, _hoisted_97),
                          _createElementVNode("tr", {
                            class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                            title: deductionTooltip('employmentInsurance')
                          }, [
                            _cache[107] || (_cache[107] = _createElementVNode("td", null, "고용보험", -1)),
                            _createElementVNode("td", _hoisted_100, _toDisplayString(formatMoney(__props.payrollDetail.employeeDeductions?.employmentInsurance || 0)), 1)
                          ], 10, _hoisted_99),
                          _createElementVNode("tr", {
                            class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                            title: deductionTooltip('incomeTax')
                          }, [
                            _cache[108] || (_cache[108] = _createElementVNode("td", null, "소득세", -1)),
                            _createElementVNode("td", _hoisted_102, _toDisplayString(formatMoney(__props.payrollDetail.employeeDeductions?.incomeTax || 0)), 1)
                          ], 10, _hoisted_101),
                          _createElementVNode("tr", {
                            class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                            title: deductionTooltip('localTax')
                          }, [
                            _cache[109] || (_cache[109] = _createElementVNode("td", null, "지방세", -1)),
                            _createElementVNode("td", _hoisted_104, _toDisplayString(formatMoney(__props.payrollDetail.employeeDeductions?.localTax || 0)), 1)
                          ], 10, _hoisted_103),
                          (__props.payrollDetail.boninPayAmount > 0)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 0,
                                class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                                title: deductionTooltip('boninPay')
                              }, [
                                _cache[110] || (_cache[110] = _createElementVNode("td", null, "본인부담금", -1)),
                                _createElementVNode("td", _hoisted_106, _toDisplayString(formatMoney(__props.payrollDetail.boninPayAmount)), 1)
                              ], 10, _hoisted_105))
                            : _createCommentVNode("", true),
                          (__props.payrollDetail.empEtcAmount > 0)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 1,
                                class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                                title: deductionTooltip('empEtc')
                              }, [
                                _cache[111] || (_cache[111] = _createElementVNode("td", null, "기타공제", -1)),
                                _createElementVNode("td", _hoisted_108, _toDisplayString(formatMoney(__props.payrollDetail.empEtcAmount)), 1)
                              ], 10, _hoisted_107))
                            : _createCommentVNode("", true),
                          (__props.payrollDetail.supportDeduction > 0)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 2,
                                class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                                title: deductionTooltip('supportDeduction')
                              }, [
                                _cache[112] || (_cache[112] = _createElementVNode("td", null, "지원공제", -1)),
                                _createElementVNode("td", _hoisted_110, _toDisplayString(formatMoney(__props.payrollDetail.supportDeduction)), 1)
                              ], 10, _hoisted_109))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("tfoot", null, [
                          _createElementVNode("tr", {
                            class: _normalizeClass({ 'has-tooltip': showAdminDeductionTooltip.value }),
                            title: deductionTooltip('totalDeduction')
                          }, [
                            _cache[113] || (_cache[113] = _createElementVNode("td", null, "공제 합계", -1)),
                            _createElementVNode("td", _hoisted_112, _toDisplayString(formatMoney(__props.payrollDetail.totalEmployeeDeduction)), 1)
                          ], 10, _hoisted_111)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "net-pay-row has-tooltip",
                    title: getPayrollTooltip('netPay')
                  }, [
                    _createElementVNode("span", _hoisted_114, _toDisplayString(formatMoney(__props.payrollDetail.totalPay)) + " - " + _toDisplayString(formatMoney(__props.payrollDetail.totalEmployeeDeduction)) + " =", 1),
                    _cache[115] || (_cache[115] = _createElementVNode("span", { class: "label" }, "실수령액", -1)),
                    _createElementVNode("span", _hoisted_115, _toDisplayString(formatMoney(__props.payrollDetail.netPay)) + "원", 1)
                  ], 8, _hoisted_113),
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("div", _hoisted_117, [
                      _cache[121] || (_cache[121] = _createElementVNode("div", { class: "block-title" }, "기관부담", -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["block-item", { 'has-tooltip': showAdminDeductionTooltip.value }]),
                        title: centerTooltip('insurance4')
                      }, [
                        _cache[116] || (_cache[116] = _createElementVNode("span", null, "4대보험", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatMoney((__props.payrollDetail.centerDeductions?.nationalPension || 0) + (__props.payrollDetail.centerDeductions?.healthInsurance || 0) + (__props.payrollDetail.centerDeductions?.longTermCare || 0) + (__props.payrollDetail.centerDeductions?.employmentInsurance || 0))) + "원", 1)
                      ], 10, _hoisted_118),
                      _createElementVNode("div", {
                        class: _normalizeClass(["block-item", { 'has-tooltip': showAdminDeductionTooltip.value }]),
                        title: centerTooltip('unemployment')
                      }, [
                        _cache[117] || (_cache[117] = _createElementVNode("span", null, "실업급여", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatMoney(__props.payrollDetail.centerDeductions?.unemployment || 0)) + "원", 1)
                      ], 10, _hoisted_119),
                      _createElementVNode("div", {
                        class: _normalizeClass(["block-item", { 'has-tooltip': showAdminDeductionTooltip.value }]),
                        title: centerTooltip('industrialAccident')
                      }, [
                        _cache[118] || (_cache[118] = _createElementVNode("span", null, "산재보험", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatMoney(__props.payrollDetail.centerDeductions?.industrialAccident || 0)) + "원", 1)
                      ], 10, _hoisted_120),
                      _createElementVNode("div", {
                        class: _normalizeClass(["block-item", { 'has-tooltip': showAdminDeductionTooltip.value }]),
                        title: centerTooltip('retirement')
                      }, [
                        _cache[119] || (_cache[119] = _createElementVNode("span", null, "퇴직금", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatMoney(__props.payrollDetail.centerDeductions?.retirement || 0)) + "원", 1)
                      ], 10, _hoisted_121),
                      _createElementVNode("div", {
                        class: _normalizeClass(["block-item total", { 'has-tooltip': showAdminDeductionTooltip.value }]),
                        title: centerTooltip('totalCenter')
                      }, [
                        _cache[120] || (_cache[120] = _createElementVNode("span", null, "합계", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatMoney(__props.payrollDetail.totalCenterDeduction)) + "원", 1)
                      ], 10, _hoisted_122)
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _cache[124] || (_cache[124] = _createElementVNode("div", { class: "block-title" }, "과세구분", -1)),
                      _createElementVNode("div", {
                        class: "block-item has-tooltip",
                        title: getTaxTooltip('taxable')
                      }, [
                        _cache[122] || (_cache[122] = _createElementVNode("span", null, "과세금액", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatMoney(__props.payrollDetail.taxableAmount)) + "원", 1)
                      ], 8, _hoisted_124),
                      _createElementVNode("div", {
                        class: "block-item has-tooltip",
                        title: getTaxTooltip('nonTaxable')
                      }, [
                        _cache[123] || (_cache[123] = _createElementVNode("span", null, "비과세금액", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatMoney(__props.payrollDetail.nonTaxableAmount)) + "원", 1)
                      ], 8, _hoisted_125)
                    ]),
                    _createElementVNode("div", _hoisted_126, [
                      _cache[127] || (_cache[127] = _createElementVNode("div", { class: "block-title" }, "기관수익", -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["block-item profit has-tooltip", { positive: __props.centerProfit > 0, negative: __props.centerProfit < 0 }]),
                        title: getProfitTooltip()
                      }, [
                        _cache[125] || (_cache[125] = _createElementVNode("span", null, "수익", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatMoney(__props.centerProfit)) + "원", 1)
                      ], 10, _hoisted_127),
                      _createElementVNode("div", {
                        class: "block-item has-tooltip",
                        title: getRetirementTooltip()
                      }, [
                        _cache[126] || (_cache[126] = _createElementVNode("span", null, "누적퇴직금", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatMoney(__props.cumulativeRetirement)) + "원", 1)
                      ], 8, _hoisted_128)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_129, [
                    _cache[132] || (_cache[132] = _createElementVNode("div", { class: "section-title" }, "직원정보", -1)),
                    _createElementVNode("div", _hoisted_130, [
                      _createElementVNode("div", _hoisted_131, [
                        _cache[128] || (_cache[128] = _createElementVNode("div", { class: "section-head" }, "일반정보", -1)),
                        _createElementVNode("div", _hoisted_132, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.employeeInfoItems, (item, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "info-item",
                              key: idx
                            }, [
                              _createVNode(_component_v_icon, {
                                size: 14,
                                color: item.color
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.icon), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"]),
                              _createElementVNode("span", null, _toDisplayString(item.text), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_133, [
                        _cache[131] || (_cache[131] = _createElementVNode("div", { class: "section-head" }, "제한사항", -1)),
                        _createElementVNode("div", _hoisted_134, [
                          (__props.restrictionItems.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.restrictionItems, (item, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "info-item warn",
                                  key: idx
                                }, [
                                  _createVNode(_component_v_icon, {
                                    size: 14,
                                    color: item.color
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]),
                                  _createElementVNode("span", null, _toDisplayString(item.text), 1)
                                ]))
                              }), 128))
                            : (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                _createVNode(_component_v_icon, {
                                  size: "14",
                                  color: "#059669"
                                }, {
                                  default: _withCtx(() => [...(_cache[129] || (_cache[129] = [
                                    _createTextVNode("mdi-check-circle", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[130] || (_cache[130] = _createElementVNode("span", null, "제한사항 없음", -1))
                              ]))
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'services')
              ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                  (__props.services.length > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_137, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              class: "sortable-th",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (toggleServiceSort('date')))
                            }, [
                              _cache[133] || (_cache[133] = _createTextVNode(" 서비스일 ", -1)),
                              _createElementVNode("span", {
                                class: _normalizeClass(["sort-icon", { active: serviceSortKey.value === 'date' }])
                              }, _toDisplayString(serviceSortKey.value === 'date' ? (serviceSortAsc.value ? '▲' : '▼') : '⇅'), 3)
                            ]),
                            _createElementVNode("th", {
                              class: "sortable-th",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (toggleServiceSort('patient')))
                            }, [
                              _cache[134] || (_cache[134] = _createTextVNode(" 수급자 ", -1)),
                              _createElementVNode("span", {
                                class: _normalizeClass(["sort-icon", { active: serviceSortKey.value === 'patient' }])
                              }, _toDisplayString(serviceSortKey.value === 'patient' ? (serviceSortAsc.value ? '▲' : '▼') : '⇅'), 3)
                            ]),
                            _createElementVNode("th", {
                              class: "sortable-th",
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (toggleServiceSort('time')))
                            }, [
                              _cache[135] || (_cache[135] = _createTextVNode(" 시간 ", -1)),
                              _createElementVNode("span", {
                                class: _normalizeClass(["sort-icon", { active: serviceSortKey.value === 'time' }])
                              }, _toDisplayString(serviceSortKey.value === 'time' ? (serviceSortAsc.value ? '▲' : '▼') : '⇅'), 3)
                            ]),
                            _createElementVNode("th", {
                              class: "sortable-th",
                              onClick: _cache[21] || (_cache[21] = ($event: any) => (toggleServiceSort('suga')))
                            }, [
                              _cache[136] || (_cache[136] = _createTextVNode(" 수가명 ", -1)),
                              _createElementVNode("span", {
                                class: _normalizeClass(["sort-icon", { active: serviceSortKey.value === 'suga' }])
                              }, _toDisplayString(serviceSortKey.value === 'suga' ? (serviceSortAsc.value ? '▲' : '▼') : '⇅'), 3)
                            ]),
                            _createElementVNode("th", {
                              class: "sortable-th",
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (toggleServiceSort('minutes')))
                            }, [
                              _cache[137] || (_cache[137] = _createTextVNode(" 서비스시간 ", -1)),
                              _createElementVNode("span", {
                                class: _normalizeClass(["sort-icon", { active: serviceSortKey.value === 'minutes' }])
                              }, _toDisplayString(serviceSortKey.value === 'minutes' ? (serviceSortAsc.value ? '▲' : '▼') : '⇅'), 3)
                            ]),
                            _createElementVNode("th", {
                              class: "sortable-th r",
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (toggleServiceSort('money')))
                            }, [
                              _cache[138] || (_cache[138] = _createTextVNode(" 수가금액 ", -1)),
                              _createElementVNode("span", {
                                class: _normalizeClass(["sort-icon", { active: serviceSortKey.value === 'money' }])
                              }, _toDisplayString(serviceSortKey.value === 'money' ? (serviceSortAsc.value ? '▲' : '▼') : '⇅'), 3)
                            ])
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedServices.value, (s, idx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(s.service_date), 1),
                                (isHoliday(s.service_date))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_138, "휴"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(s.patient_name), 1),
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(s.start_time) + "~" + _toDisplayString(s.end_time), 1),
                                (s.is_lunch_time)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_139, "식대"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", {
                                class: _normalizeClass({ family: s.suga_name?.includes('가족') })
                              }, _toDisplayString(s.suga_name), 3),
                              _createElementVNode("td", null, _toDisplayString(formatMinutes(s.service_minutes)), 1),
                              _createElementVNode("td", _hoisted_140, _toDisplayString(formatMoney(s.suga_money || 0)) + "원", 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_141, "서비스 내역이 없습니다.")),
                  (severeCareDaily.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, [
                          _cache[139] || (_cache[139] = _createTextVNode("중증수급자 가산 ", -1)),
                          _createElementVNode("span", _hoisted_144, "합계: " + _toDisplayString(formatMoney(severeCareTotal.value)) + "원 (" + _toDisplayString(severeCareDaily.value.length) + "회)", 1)
                        ]),
                        _createElementVNode("table", _hoisted_145, [
                          _cache[140] || (_cache[140] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "일자"),
                              _createElementVNode("th", null, "수급자"),
                              _createElementVNode("th", null, "수가명"),
                              _createElementVNode("th", { class: "r" }, "금액")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(severeCareDaily.value, (item, idx) => {
                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                _createElementVNode("td", null, _toDisplayString(formatServiceDate(item.service_date)), 1),
                                _createElementVNode("td", null, _toDisplayString(item.patient_name || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(item.suga_name), 1),
                                _createElementVNode("td", _hoisted_146, _toDisplayString(formatMoney(item.suga_money || 0)) + "원", 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'weekly')
              ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                  (__props.weeklyServices.length > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_148, [
                        _cache[141] || (_cache[141] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "주차"),
                            _createElementVNode("th", null, "서비스일"),
                            _createElementVNode("th", null, "일일시간"),
                            _createElementVNode("th", null, "주간합계")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.weeklyServices, (week, wIdx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: wIdx }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week.daily_items, (daily, dIdx) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: `${wIdx}-${dIdx}`,
                                  class: _normalizeClass({ 'week-start': dIdx === 0 })
                                }, [
                                  (dIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 0,
                                        rowspan: week.daily_items.length,
                                        class: "week-cell"
                                      }, _toDisplayString(week.service_week) + "주차", 9, _hoisted_149))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", null, [
                                    _createTextVNode(_toDisplayString(daily.service_date), 1),
                                    (isHoliday(daily.service_date))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_150, "휴"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", {
                                    class: _normalizeClass({ over: daily.daily_total_hours > 8 })
                                  }, _toDisplayString(daily.daily_total_hours) + "시간", 3),
                                  (dIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 1,
                                        rowspan: week.daily_items.length,
                                        class: _normalizeClass(["week-cell", { over: week.weekly_total_hours > 40 }])
                                      }, _toDisplayString(week.weekly_total_hours) + "시간", 11, _hoisted_151))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ], 64))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_152, "주차별 근무내역이 없습니다."))
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'calendar')
              ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                  _createVNode(WageEmployeeCalendar, {
                    "year-month": __props.yearMonth || '',
                    services: calendarServices.value,
                    holidays: __props.holidays
                  }, null, 8, ["year-month", "services", "holidays"])
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'settings')
              ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("div", _hoisted_156, [
                      _cache[146] || (_cache[146] = _createElementVNode("div", { class: "section-head" }, "4대보험", -1)),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: __props.settings?.applyNationalPension,
                          onChange: _cache[24] || (_cache[24] = ($event: any) => (updateSetting('applyNationalPension', ($event.target as HTMLInputElement).checked))),
                          disabled: __props.isConfirmed
                        }, null, 40, _hoisted_157),
                        _cache[142] || (_cache[142] = _createTextVNode(" 국민연금 ", -1)),
                        (__props.settings?.applyNationalPension)
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              class: "inline-input",
                              value: __props.settings?.yeonPay,
                              onInput: _cache[25] || (_cache[25] = ($event: any) => (updateSetting('yeonPay', ($event.target as HTMLInputElement).value))),
                              disabled: __props.isConfirmed
                            }, null, 40, _hoisted_158))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: __props.settings?.applyHealthInsurance,
                          onChange: _cache[26] || (_cache[26] = ($event: any) => (updateSetting('applyHealthInsurance', ($event.target as HTMLInputElement).checked))),
                          disabled: __props.isConfirmed
                        }, null, 40, _hoisted_159),
                        _cache[143] || (_cache[143] = _createTextVNode(" 건강보험 ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_160, [
                        _createElementVNode("label", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: __props.settings?.applyEmploymentInsurance,
                            onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.$emit('open-employment-modal', __props.groupIndex)), ["prevent"])),
                            disabled: __props.isConfirmed
                          }, null, 8, _hoisted_161),
                          _cache[144] || (_cache[144] = _createTextVNode(" 고용보험 ", -1))
                        ]),
                        (!__props.settings?.applyEmploymentInsurance && __props.settings?.applyUnemployment)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_162, "실업급여만"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: __props.settings?.applyRetirement,
                          onChange: _cache[28] || (_cache[28] = ($event: any) => (updateSetting('applyRetirement', ($event.target as HTMLInputElement).checked))),
                          disabled: __props.isConfirmed
                        }, null, 40, _hoisted_163),
                        _cache[145] || (_cache[145] = _createTextVNode(" 퇴직금 적립 ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_164, [
                      _cache[151] || (_cache[151] = _createElementVNode("div", { class: "section-head" }, "수당", -1)),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: __props.settings?.applyHoliday,
                          onChange: _cache[29] || (_cache[29] = ($event: any) => (updateSetting('applyHoliday', ($event.target as HTMLInputElement).checked))),
                          disabled: __props.isConfirmed
                        }, null, 40, _hoisted_165),
                        _cache[147] || (_cache[147] = _createTextVNode(" 휴일수당 ", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: __props.settings?.applyOvertime,
                          onChange: _cache[30] || (_cache[30] = ($event: any) => (updateSetting('applyOvertime', ($event.target as HTMLInputElement).checked))),
                          disabled: __props.isConfirmed
                        }, null, 40, _hoisted_166),
                        _cache[148] || (_cache[148] = _createTextVNode(" 연장수당 ", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: __props.settings?.applyMeal,
                          onChange: _cache[31] || (_cache[31] = ($event: any) => (updateSetting('applyMeal', ($event.target as HTMLInputElement).checked))),
                          disabled: __props.isConfirmed
                        }, null, 40, _hoisted_167),
                        _cache[149] || (_cache[149] = _createTextVNode(" 식대 ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_168, [
                        _cache[150] || (_cache[150] = _createElementVNode("span", null, "기타수당", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          value: __props.settings?.etcAllowance,
                          onInput: _cache[32] || (_cache[32] = ($event: any) => (handleEtcAllowanceInput($event))),
                          onBlur: _cache[33] || (_cache[33] = ($event: any) => (handleEtcAllowanceBlur($event))),
                          disabled: __props.isConfirmed,
                          placeholder: "0"
                        }, null, 40, _hoisted_169)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_170, [
                      _cache[156] || (_cache[156] = _createElementVNode("div", { class: "section-head" }, "추가항목", -1)),
                      _createElementVNode("div", _hoisted_171, [
                        _cache[152] || (_cache[152] = _createElementVNode("span", null, "장기근속수당", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          value: __props.settings?.longServicePay,
                          onInput: _cache[34] || (_cache[34] = ($event: any) => (handleLongServicePayInput($event))),
                          onBlur: _cache[35] || (_cache[35] = ($event: any) => (handleLongServicePayBlur($event))),
                          disabled: __props.isConfirmed
                        }, null, 40, _hoisted_172)
                      ]),
                      _createElementVNode("div", _hoisted_173, [
                        _cache[153] || (_cache[153] = _createElementVNode("span", null, "보수교육비", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          value: __props.settings?.bosuEduPay,
                          onInput: _cache[36] || (_cache[36] = ($event: any) => (handleBosuEduPayInput($event))),
                          onBlur: _cache[37] || (_cache[37] = ($event: any) => (handleBosuEduPayBlur($event))),
                          disabled: __props.isConfirmed
                        }, null, 40, _hoisted_174)
                      ]),
                      _createElementVNode("div", _hoisted_175, [
                        _cache[154] || (_cache[154] = _createElementVNode("span", null, "본인부담금", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          value: __props.settings?.boninPay,
                          readonly: "",
                          class: _normalizeClass({ 'clickable': hasFamilySuga.value && !__props.isConfirmed, 'not-applicable': !hasFamilySuga.value }),
                          onClick: handleBoninPayClick,
                          disabled: __props.isConfirmed,
                          placeholder: hasFamilySuga.value ? '클릭하여 비율 선택' : '해당없음'
                        }, null, 10, _hoisted_176)
                      ]),
                      _createElementVNode("div", _hoisted_177, [
                        _cache[155] || (_cache[155] = _createElementVNode("span", null, "기타공제", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          value: __props.settings?.empEtc,
                          onInput: _cache[38] || (_cache[38] = ($event: any) => (handleEmpEtcInput($event))),
                          onBlur: _cache[39] || (_cache[39] = ($event: any) => (handleEmpEtcBlur($event))),
                          disabled: __props.isConfirmed
                        }, null, 40, _hoisted_178)
                      ])
                    ])
                  ]),
                  (__props.employee?.patients && __props.employee.patients.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                        _cache[159] || (_cache[159] = _createElementVNode("div", { class: "section-head" }, "수급자별 시급 및 수가시간", -1)),
                        _createElementVNode("table", _hoisted_180, [
                          _cache[158] || (_cache[158] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "수급자"),
                              _createElementVNode("th", null, "수가명"),
                              _createElementVNode("th", null, "서비스횟수"),
                              _createElementVNode("th", null, "수가시간"),
                              _createElementVNode("th", null, "시급"),
                              _createElementVNode("th", { class: "r" }, "합계금액")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.employee.patients, (p, pIdx) => {
                              return (_openBlock(), _createElementBlock("tr", { key: pIdx }, [
                                _createElementVNode("td", null, _toDisplayString(p.patientName), 1),
                                _createElementVNode("td", {
                                  class: _normalizeClass({ family: p.sugaName?.includes('가족'), holiday: isHolidaySuga(p.sugaName) })
                                }, [
                                  _createTextVNode(_toDisplayString(p.sugaName) + " ", 1),
                                  (isHolidaySuga(p.sugaName))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_181, "휴일수당"))
                                    : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("td", _hoisted_182, _toDisplayString(p.serviceDays || 0) + "회", 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("button", {
                                    class: "suga-hours-btn",
                                    onClick: ($event: any) => (_ctx.$emit('open-suga-hours-modal', __props.groupIndex, p)),
                                    disabled: __props.isConfirmed
                                  }, _toDisplayString(getDisplaySugaHours(p)) + "시간 ", 9, _hoisted_183)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("input", {
                                    type: "text",
                                    class: "timepay-input",
                                    value: getTimePay(p),
                                    onInput: ($event: any) => (updateTimePay(p, ($event.target as HTMLInputElement).value)),
                                    disabled: __props.isConfirmed
                                  }, null, 40, _hoisted_184)
                                ]),
                                _createElementVNode("td", _hoisted_185, [
                                  _createTextVNode(_toDisplayString(formatMoney(getPatientTotalAmount(p))) + "원 ", 1),
                                  (isHolidaySuga(p.sugaName) && __props.settings?.applyHoliday && getPatientHolidayAllowance(p) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_186, " (휴일 +" + _toDisplayString(formatMoney(getPatientHolidayAllowance(p))) + "원 포함) ", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("tfoot", null, [
                            _createElementVNode("tr", null, [
                              _cache[157] || (_cache[157] = _createElementVNode("td", {
                                colspan: "5",
                                class: "r"
                              }, "합계", -1)),
                              _createElementVNode("td", _hoisted_187, [
                                _createTextVNode(_toDisplayString(formatMoney(getAllPatientsTotalAmount())) + "원 ", 1),
                                (getTotalHolidayAllowance() > 0 && __props.settings?.applyHoliday)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_188, " (휴일 +" + _toDisplayString(formatMoney(getTotalHolidayAllowance())) + "원 포함) ", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_189, [
                    _createElementVNode("button", {
                      class: "action-btn load-prev",
                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.$emit('load-previous-settings', __props.groupIndex))),
                      disabled: __props.isConfirmed
                    }, " 과거정보 가져오기 ", 8, _hoisted_190),
                    _createElementVNode("button", {
                      class: "action-btn reset",
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.$emit('reset-settings', __props.groupIndex))),
                      disabled: __props.isConfirmed || !__props.hasChanges
                    }, " 되돌리기 ", 8, _hoisted_191),
                    _createElementVNode("button", {
                      class: _normalizeClass(["action-btn save", { unsaved: __props.hasChanges }]),
                      onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.$emit('save-settings'))),
                      disabled: __props.isConfirmed || __props.isSaving
                    }, [
                      (__props.isSaving)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_193, "저장 중..."))
                        : (_openBlock(), _createElementBlock("span", _hoisted_194, _toDisplayString(__props.hasChanges ? '저장필요' : '저장'), 1))
                    ], 10, _hoisted_192)
                  ]),
                  _createElementVNode("div", _hoisted_195, [
                    _cache[164] || (_cache[164] = _createElementVNode("div", { class: "section-title" }, "직원정보", -1)),
                    _createElementVNode("div", _hoisted_196, [
                      _createElementVNode("div", _hoisted_197, [
                        _cache[160] || (_cache[160] = _createElementVNode("div", { class: "section-head" }, "일반정보", -1)),
                        _createElementVNode("div", _hoisted_198, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.employeeInfoItems, (item, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "info-item",
                              key: idx
                            }, [
                              _createVNode(_component_v_icon, {
                                size: 14,
                                color: item.color
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.icon), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"]),
                              _createElementVNode("span", null, _toDisplayString(item.text), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_199, [
                        _cache[163] || (_cache[163] = _createElementVNode("div", { class: "section-head" }, "제한사항", -1)),
                        _createElementVNode("div", _hoisted_200, [
                          (__props.restrictionItems.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.restrictionItems, (item, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "info-item warn",
                                  key: idx
                                }, [
                                  _createVNode(_component_v_icon, {
                                    size: 14,
                                    color: item.color
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]),
                                  _createElementVNode("span", null, _toDisplayString(item.text), 1)
                                ]))
                              }), 128))
                            : (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                _createVNode(_component_v_icon, {
                                  size: "14",
                                  color: "#059669"
                                }, {
                                  default: _withCtx(() => [...(_cache[161] || (_cache[161] = [
                                    _createTextVNode("mdi-check-circle", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[162] || (_cache[162] = _createElementVNode("span", null, "제한사항 없음", -1))
                              ]))
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})